import { PlusOutlined } from '@ant-design/icons';
import { Button, Form, Input, Select, message } from 'antd';
import React, { useEffect, useState } from 'react';
import { reqAddClient, reqRoles } from '../../../../api';
import Fragment from '../../../../components/fragment';

const { Option } = Select;
const ShowRole = ({ setForm, cancelAdd, getClients }) => {
  const [roles, setRoles] = useState([]);
  const [form] = Form.useForm();
  useEffect(() => {
    setForm(form);
  });
  const addClient = async (values) => {
    const result = await reqAddClient(values);
    if (result.status === 200) {
      message.success('添加客户端成功');
      cancelAdd();
      getClients();
    } else {
      message.error(result.error);
    }
  };
  const onFinish = (values) => {
    addClient(values);
  };
  const getRoles = async () => {
    const data = {
      verbose: '100',
      type: '0',
    };

    const result = await reqRoles(data);
    if (result.status === 200) {
      const roles = result.result;
      setRoles(roles);
    }
  };
  useEffect(() => {
    getRoles();
  }, []);
  return (
    <Form
      name="add_client"
      onFinish={onFinish}
      form={form}
      autoComplete="off"
      labelCol={{
        span: 4,
      }}
      wrapperCol={{
        span: 16,
      }}>
      <Form.Item label="app_id" name="app_id">
        <Input />
      </Form.Item>
      <Form.Item label="认证方式" name="grant_type">
        <Select>
          <Option value="api_key">api_key</Option>
          <Option value="client_credential">client_credential</Option>
        </Select>
      </Form.Item>
      <Form.Item label="Client类型" name="client_type">
        <Select>
          <Option value="external">external</Option>
          <Option value="internal">internal</Option>
        </Select>
      </Form.Item>
      <Form.Item label="名称" name="client_name">
        <Input />
      </Form.Item>
      <Form.List name="roles">
        {(fields, { add, remove }) => (
          <>
            {fields.map((field) => (
              <Fragment
                field={field}
                remove={remove}
                key={field.key}
                roles={roles}
              />
            ))}
            <Form.Item
              wrapperCol={{
                offset: 4,
                span: 16,
              }}>
              <Button
                type="dashed"
                onClick={() => add()}
                block
                icon={<PlusOutlined />}>
                增加角色
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
      <Form.Item
        wrapperCol={{
          offset: 8,
          span: 16,
        }}>
        <Button type="primary" htmlType="submit">
          保存
        </Button>
      </Form.Item>
    </Form>
  );
};
export default ShowRole;
